import React from 'react';
import { motion } from 'framer-motion';

interface PagerProps {
  children: React.ReactNode;
  value: number;
}

export function Pager({ children, value }: Readonly<PagerProps>) {
  return (
    <div className="flex flex-col overflow-hidden w-full">
      <motion.div
        className="flex flex-row min-h-0 flex-1 will-change-transform"
        transition={{
          tension: 190,
          friction: 70,
          mass: 0.4,
        }}
        initial={false}
        animate={{ x: value * -100 + '%' }}
      >
        {React.Children.map(children, (child, i) => (
          <div
            key={i}
            className={`flex flex-col w-full self-stretch justify-start flex-shrink-0 overflow-hidden outline-none ${
              value === i ? 'h-full' : 'h-0'
            }`}
            aria-hidden={value !== i}
            tabIndex={value === i ? 0 : -1}
          >
            {/* @ts-ignore */}
            {child}
          </div>
        ))}
      </motion.div>
    </div>
  );
}
